<div class="not-found">
  <mat-icon class="material-icons-outlined not-found__icon">search_off</mat-icon>
  <div class="not-found__header">Page Not Found</div>
  <div class="not-found__info">The page you're looking for doesn't exist. <br />It may have been moved or deleted.</div>
  <a mat-flat-button class="not-found__button" [href]="'overview'">Go Home</a>
</div>
